"use client";

import React, { useEffect, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface SelectOrderProps {
    initialOrder: string;
    compact?: boolean;
    className?: string;
}

export default function SelectOrder({ initialOrder, compact = false, className = "" }: SelectOrderProps) {
    const [order, setOrder] = useState(initialOrder);
    const router = useRouter();
    const searchParams = useSearchParams();

    useEffect(() => {
        setOrder(initialOrder);
    }, [initialOrder]);

    const handleChange = (value: string) => {
        setOrder(value);
        const params = new URLSearchParams(searchParams as any);
        params.set("order", value);
        router.push(`?${params.toString()}`);
    };

    const triggerClasses = [
        compact
            ? "min-h-10 h-auto text-sm px-3 py-2 [&>span]:line-clamp-2 [&>span]:whitespace-normal"
            : "min-h-10 h-auto py-2 [&>span]:line-clamp-2 [&>span]:whitespace-normal",
        className
    ].filter(Boolean).join(" ");

    return (
        <Select value={order} onValueChange={handleChange}>
            <SelectTrigger
                id="ordina__per"
                aria-label="Seleziona l'ordine dei risultati"
                className={triggerClasses || undefined}
            >
                <SelectValue placeholder="Ordina per Articolo" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value="prezzo_DESC">Ordina per prezzo decrescente</SelectItem>
                <SelectItem value="prezzo_ASC">Ordina per prezzo crescente</SelectItem>
                <SelectItem value="anno_DESC">Ordina per anno decrescente</SelectItem>
                <SelectItem value="anno_ASC">Ordina per anno crescente</SelectItem>
                <SelectItem value="km_DESC">Ordina per km decrescente</SelectItem>
                <SelectItem value="km_ASC">Ordina per km crescente</SelectItem>
            </SelectContent>
        </Select>
    );
}
